export const WINNER_TITLE_TEXT_TYPE = 'h3';
export const WINNER_TITLE = 'Winner';
export const WINNER_PICTURE_ALT = ' Profile Picture';
export const WINNER_SUBTTITLE_TEXT_TYPE = 'h4';
export const WINNER_SUBTITLE = 'Top bidder';
export const TOP_BID_SUBTITLE = 'Top bid';
export const WINNER_BANNER_IMAGE_ALT = 'Winner announcement';
export const WINNER_BANNER_DEFAULT_ASPECT_RATIO = '16-9';
